import { AppConfigService } from '../../../app-config.service';
import { BffCommunicationService } from '../../../core/services/_index';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreautorisationEnLigneApiService {
  constructor(
    private readonly _bffApiService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService
  ) {}

  private getBaseApiUrlV1(): string {
    const idProjet = this._appConfigService.configData ? this._appConfigService.idProjet : null;
    return `/api/v1/projets/${idProjet}`;
  }

  private getBaseApiUrlV2(): string {
    const idProjet = this._appConfigService.configData ? this._appConfigService.idProjet : null;
    return `/api/v2/projets/${idProjet}`;
  }

  private getPreAuthApiUrlV1(): string {
    return `${this.getBaseApiUrlV1()}/preautorisationsenligne`;
  }

  private getPreAuthApiUrlV2(): string {
    return `${this.getBaseApiUrlV2()}/preautorisationsenligne`;
  }

  initPreautorisation(): Observable<any> {
    return this._bffApiService.getJSONBFF(`${this.getPreAuthApiUrlV1()}/initialiser`) as Observable<any>;
  }

  getPreautorisation(): Observable<any> {
    return this._bffApiService.getJSONBFF(this.getPreAuthApiUrlV1()) as Observable<any>;
  }

  submitPreautorisation(preautorisation: any, consentId: string, numeroDemande?: string): Observable<any> {
    const numeroDemandeParam = numeroDemande ? `&numeroDemande=${numeroDemande}` : '';

    return this._bffApiService.postJSONBFF(
      `${this.getPreAuthApiUrlV2()}?idTexteConsentement=${consentId}${numeroDemandeParam}`,
      preautorisation
    );
  }

  deletePreautorisation(idPreautorisation: string, codeInvitation?: string): Observable<Object> {
    let url = `${this.getPreAuthApiUrlV1()}/${idPreautorisation}`;
    if (codeInvitation) {
      url += `?codeInvitation=${codeInvitation}`;
    }
    return this._bffApiService.deleteBFF(url);
  }

  getPreautorisationDocument(idPreautorisation: string, documentPath: string): Observable<ArrayBuffer> {
    return this._bffApiService.getPdfBFF(`${this.getPreAuthApiUrlV1()}/${idPreautorisation}/${documentPath}`);
  }
}
